import { jsx as _jsx } from "react/jsx-runtime";
import IconButton from '@material-ui/core/IconButton';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import CopyIcon from '@material-ui/icons/FileCopy';
import RemoveIcon from '@material-ui/icons/Remove';
import { TranslatableString } from '@rjsf/utils';
export default function MuiIconButton(props) {
    const { icon, color, uiSchema, registry, ...otherProps } = props;
    return (_jsx(IconButton, { ...otherProps, size: 'small', color: color, children: icon }));
}
export function CopyButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(MuiIconButton, { title: translateString(TranslatableString.CopyButton), ...props, icon: _jsx(CopyIcon, { fontSize: 'small' }) }));
}
export function MoveDownButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(MuiIconButton, { title: translateString(TranslatableString.MoveDownButton), ...props, icon: _jsx(ArrowDownwardIcon, { fontSize: 'small' }) }));
}
export function MoveUpButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(MuiIconButton, { title: translateString(TranslatableString.MoveUpButton), ...props, icon: _jsx(ArrowUpwardIcon, { fontSize: 'small' }) }));
}
export function RemoveButton(props) {
    const { iconType, ...otherProps } = props;
    const { registry: { translateString }, } = otherProps;
    return (_jsx(MuiIconButton, { title: translateString(TranslatableString.RemoveButton), ...otherProps, color: 'secondary', icon: _jsx(RemoveIcon, { fontSize: iconType === 'default' ? 'medium' : 'small' }) }));
}
//# sourceMappingURL=IconButton.js.map